<div class="d-flex align-items-center"  style="height: 30px;">
    <div class="step" *ngFor="let step of steps; index as i" 
    [ngClass]="{ active: i === current, success: i < current,  next: i > current}"
    data-aos="fade-down"
    data-aos-easing="linear"
    data-aos-duration="1000">
        <div class="icon" ><img class="poscalm-icon pt-4 mt-2" src="./assets/logos/comprobado.png" style="width:24px;"></div>
        <div class="step-label">{{ i + 1 }}</div>
    </div>
</div>